<template>
    <div class="no-data-page page">
        <div class="no-data-content">
            <v-icon
                size="80"
                color="#bdbdbd"
            >
                mdi-file-document-outline
            </v-icon>
            <h2 class="title">
                目前沒有需要評分的項目
            </h2>
            <p class="description">
                您尚未被分配任何項目，如有問題請聯繫管理員。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubmittedRatingNoData',
};
</script>

<style lang="scss" scoped>
.no-data-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.no-data-content {
    text-align: center;

    .title {
        margin-top: 20px;
        font-size: 24px;
        color: #424242;
    }

    .description {
        margin-top: 12px;
        font-size: 16px;
        color: #757575;
    }
}
</style>
